import {
  userMenuList,
  adminMenuList,
  csMenuList,
  trackingMenuList, joinedMenuList,
} from '../../../data/nav';
import NavItem from './NavItem';
import { useLoginStore } from '../../../store/useLogin';

/**
 * @author taulmax
 * @date 2024.09.27
 * @description 네비게이션
 */
const Nav = () => {
  const { role } = useLoginStore();
  const menuObj = {
    ROLE_ADMIN: adminMenuList,
    ROLE_USER: userMenuList,
    ROLE_CS: csMenuList,
    ROLE_TRACKING: trackingMenuList,
    ROLE_JOINED : joinedMenuList,
    ROLE_MARKETING: userMenuList,
  };
  const menuList = menuObj[role];

  return (
    <nav className="!flex-1 !overflow-y-auto !px-4 !py-6 !relative">
      <ul className="!space-y-1 !relative">
        {menuList.map(menu => (
          <NavItem
            key={menu.menu}
            menu={menu.menu}
            link={menu.link}
            icon={menu.icon}
            children={menu.children}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
